import React from "react";
import { X, Loader2 } from "lucide-react";

const AiAnalysisModal = ({ isOpen, onClose, call, source, onRegenerateSTTandAI, onRegenerateAIOnly, generating }) => {
  if (!isOpen || !call) return null;

  const transcript = call.ai_analized_transcript || call.ai_transcript || "No transcript available.";
  let enhanced = null;
  try {
    enhanced = call.ai_enhanced_response ? JSON.parse(call.ai_enhanced_response) : null;
  } catch {
    enhanced = call.ai_enhanced_response;
  }

  const isGenerating = generating[call.id] || false;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold text-gray-800">AI Analysis</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={20} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-4 text-left">
          <div>
            <h3 className="text-sm font-medium text-gray-700 mb-1">Transcript</h3>
            <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-800 whitespace-pre-wrap max-h-48 overflow-y-auto border">{transcript}</div>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-700 mb-1">Enhanced Response</h3>
            <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-800 border overflow-x-auto">{enhanced ? typeof enhanced === "object" ? <pre className="whitespace-pre-wrap break-words">{JSON.stringify(enhanced, null, 2)}</pre> : <div className="whitespace-pre-wrap break-words">{enhanced}</div> : "No enhanced data."}</div>
          </div>
          {call.ai_status && (
            <div className="text-xs text-gray-500">
              Status: <span className="font-medium">{call.ai_status}</span>
            </div>
          )}
          {call.ai_error_message && <div className="text-xs text-red-500">Error: {call.ai_error_message}</div>}
        </div>
        {/* Footer with regeneration buttons */}
        <div className="p-4 border-t flex flex-wrap items-center justify-between gap-3">
          <div className="flex gap-2">
            <button onClick={() => onRegenerateSTTandAI(call, source)} disabled={isGenerating} className="px-4 py-2 text-sm rounded-md bg-indigo-100 text-indigo-700 hover:bg-indigo-200 disabled:opacity-50 disabled:cursor-wait transition flex items-center gap-2">
              {isGenerating ? <Loader2 size={16} className="animate-spin" /> : null}
              Regenerate STT & AI
            </button>
            <button onClick={() => onRegenerateAIOnly(call, source)} disabled={isGenerating} className="px-4 py-2 text-sm rounded-md bg-amber-100 text-amber-700 hover:bg-amber-200 disabled:opacity-50 disabled:cursor-wait transition flex items-center gap-2">
              {isGenerating ? <Loader2 size={16} className="animate-spin" /> : null}
              Regenerate AI Only
            </button>
          </div>
          <button onClick={onClose} className="px-4 py-2 text-sm rounded-md bg-gray-100 hover:bg-gray-200 transition">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AiAnalysisModal;
